import React from 'react'

import image1 from '../../Assets/1.png'
import image2 from '../../Assets/2.png'
import image4 from '../../Assets/4.png'
import image3 from '../../Assets/3.png'
import image7 from '../../Assets/7.png'
import image6 from '../../Assets/6.png'
import image5 from '../../Assets/5.png'
import image8 from '../../Assets/8.png'
import image9 from '../../Assets/9.png'




const Home = () => {
  return (
    <div>
      <button className="btn_center">Electronic and Communication Engineering Department </button>
	

	  
    <div className="slider">
	<input type="radio" name="testimonial" id="t-1"/>
	<input type="radio" name="testimonial" id="t-2"/>
	<input type="radio" name="testimonial" id="t-3" checked/>
	<input type="radio" name="testimonial" id="t-4"/>
	<input type="radio" name="testimonial" id="t-5"/>
	
	<div class="testimonials">
		<label className="item" for="t-1">
			<img src={image1} alt="Placement Glimpse"/>
		
		</label>
		<label className="item" for="t-2">
			<img src={image6} alt="Placement Glimpse"/>
			
		</label>
		<label className="item" for="t-3">
			<img src={image7} alt="Placement Glimpse"/>
		
		</label>
		<label className="item" for="t-4">
			<img src={image2} alt="Placement Glimpse"/>
			
		</label>
		<label className="item" for="t-5">
			<img src={image9} alt="Placement Glimpse"/>
		</label>
		
	</div>
	</div>

	
	<div className="containerhh">
	
	<div className="cardhh">
	  <div className="card-titlehh">About EC Department</div>
	  <div className="card-texthh" style={{textAlign:'center'}}>
	  The Electronics and Communication Engineering Department, founded in 1995, is renowned for its groundbreaking research in VLSI and Communication. Over the years, it has continually evolved and expanded its focus to encompass various domains, including entertainment, automation, healthcare systems, IoT, robotics, global communication, VLSI design, and embedded systems. The department places equal emphasis on academics and research, providing students with the opportunity to develop a robust academic and research portfolio.

	  Through a blend of innovative learning techniques, students are exposed to a comprehensive educational experience that combines theoretical knowledge with practical, hands-on training in state-of-the-art laboratories. The department's dedication to excellence is exemplified by its BTech program, which holds accreditation from the National Board of Accreditation (NBA) in the prestigious Tier-I category.
	  
	  The department offers a range of educational programs, including undergraduate, postgraduate, and doctoral degrees, with specializations in three key domains: Communications, VLSI, and Embedded Systems. To deliver these programs, the department boasts a team of highly qualified and experienced faculty members who are deeply committed to both teaching and cutting-edge research.
	  
	  One of the department's strengths lies in its well-equipped laboratories, which provide a conducive environment for exploration and experimentation. Additionally, the department takes pride in its exceptional students and strong connections with the industrial sector.
	  
	  A noteworthy achievement of the department is the development of a radiation-hardened chip designed to absorb radiation, prevent failure, and self-heal in the presence of radiation in space environments. This groundbreaking innovation has garnered the approval of SAC-ISRO and earned recognition, including the opportunity for presentation at the prestigious NASA Langley Research Center.
	  </div>
	</div>
  
  </div>
	  
	
	 

    </div>
  )
}

export default Home